import axios from "axios";

export const API = `${process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "vaya_token";

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const apiError = (e) =>
  e?.response?.data?.detail
    ? typeof e.response.data.detail === "string"
      ? e.response.data.detail
      : JSON.stringify(e.response.data.detail)
    : e?.message || "Something went wrong";

// Locations rarely change; cache the last good result so a flaky network
// (some ISPs drop the XHR) never leaves the booking form with empty dropdowns.
const LOC_CACHE_KEY = "vaya_locations_v1";

export const getCachedLocations = () => {
  try {
    const v = JSON.parse(localStorage.getItem(LOC_CACHE_KEY));
    return Array.isArray(v) ? v : [];
  } catch {
    return [];
  }
};

export const fetchLocations = async (retries = 3) => {
  let lastErr;
  for (let i = 0; i < retries; i++) {
    try {
      const { data } = await api.get("/locations", { timeout: 12000 });
      const locs = data.locations || [];
      if (locs.length) localStorage.setItem(LOC_CACHE_KEY, JSON.stringify(locs));
      return locs;
    } catch (e) {
      lastErr = e;
      if (i < retries - 1) await new Promise((r) => setTimeout(r, 700 * (i + 1)));
    }
  }
  throw lastErr;
};

export const eur = (n) =>
  new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" }).format(
    Number(n || 0)
  );
